import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"

//Include Both Helperith needed methods

 
import {
  postFakeForgetPwd,

} from "../../../helpers/backend_helper";



export const userForgetPassword = (user : any, history : any) => async (dispatch : any) => {
  try {
      let response;
      {
          response = postFakeForgetPwd(
              user.email
          )
      }

      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(
              "We've emailed you a 6-digit reset code. Check your inbox."
          ))
      }
  } catch (forgetError: any) {
      dispatch(userForgetPasswordError(
        forgetError?.response?.data?.message || forgetError?.message || 'Failed to send reset code. Please try again.'
      ))
  }
}